var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1113 3.11035H5.88868C5.74979 3.11035 5.61784 3.1798 5.54144 3.29786L2.0691 8.40914C1.96841 8.56193 1.97882 8.76332 2.09341 8.90222L11.6771 20.736C11.8437 20.9408 12.1563 20.9408 12.3229 20.736L21.9066 8.90222C22.0212 8.75985 22.0316 8.56193 21.9309 8.40914L18.462 3.29786C18.3822 3.1798 18.2537 3.11035 18.1113 3.11035ZM17.4412 4.77708L19.6392 8.11052H17.2641L15.4689 4.77708H17.4412V4.77708ZM10.4236 4.77708H13.573L15.3682 8.11052H8.63183L10.4236 4.77708ZM6.55884 4.77708H8.53113L6.73593 8.11052H4.36085L6.55884 4.77708ZM5.06573 9.77725H6.85052L9.22213 15.333L5.06573 9.77725V9.77725ZM8.63877 9.77725H15.3612L12 18.2255L8.63877 9.77725V9.77725ZM14.7779 15.333L17.146 9.77725H18.9308L14.7779 15.333Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGem);
export default __webpack_public_path__ + "static/media/Gem.c66d77fd4a622c64eb18615bcb8b70ad.svg";
export { ForwardRef as ReactComponent };